import { CdkAccordionModule } from '@angular/cdk/accordion';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterLink } from '@angular/router';
import { RouterLinkDetectorDirective } from 'app/core/directives/router-link-detector.directive';
import { MenuChildren } from 'app/core/models/menu-children.model';
import { ShebaGtmClickDirective } from 'app/core/services/google-tag-manager/gtm.directive';
import { SharedService } from 'app/core/services/shared.service';
import { ArrowDownIcon } from '../../../../assets/icons/arrow-down/arrow-down';
import { CmsMediaPrefixPipe } from 'app/core/pipes/cms-media-prefix.pipe';
import { SanitizeUrlPipe } from 'app/core/pipes/sanitize-url.pipe';

@Component({
  selector: 'sheba-navigation',
  templateUrl: 'navigation.component.html',
  host: {
    class: 'contents'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatRippleModule,
    RouterLinkDetectorDirective,
    NgTemplateOutlet,
    CdkAccordionModule,
    NgClass,
    MatExpansionModule,
    RouterLink,
    ArrowDownIcon,
    ShebaGtmClickDirective,
    CmsMediaPrefixPipe,
    SanitizeUrlPipe
  ]
})
export class NavigationComponent {
  navigation = input<MenuChildren[]>([]);
  class = input<string>('');
  lightMode = inject(SharedService).lightMode;
}
